import { Heading2, Heading3 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { color, container, fontSize, radius, screen, spacing } from 'theme';

export const StyledWrapper = styled.div`
  max-width: ${container('xl')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  margin: ${spacing('xl5')} auto;

  ${Heading2} {
    text-align: center;
    margin-bottom: ${spacing('xl2')};
  }
`;

export const StyledFeature = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};
  margin-bottom: ${spacing('xl4')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    align-items: center;
    justify-content: center;

    &.reverse {
      flex-direction: row-reverse;
    }
  }

  > div {
    line-height: 1.5;

    @media (min-width: ${screen('md')}) {
      max-width: 50%;
    }

    :last-child {
      margin-bottom: 0;
    }
  }

  ${Heading3} {
    margin-top: 0;
    margin-bottom: ${spacing('lg')};
  }

  ol {
    padding-left: ${spacing('md')};

    li {
      list-style: auto;
    }
  }

  img {
    width: 100%;
    max-width: 33rem;
    margin: auto;

    @media (min-width: ${screen('md')}) {
      width: 50%;
    }
  }
`;

export const StyledHighlight = styled.div`
  max-width: ${container('md')};
  margin: ${spacing('xl5')} auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${spacing('md')};

  p {
    margin: 0;
    color: ${color('text_subtle')};
    line-height: 1.5;
  }
`;

export const StyledHighlightIcon = styled.div`
  width: ${spacing('xl4')};
  height: ${spacing('xl4')};
  border-radius: ${radius('full')};
  background-color: ${color('info_500')};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${color('white')};
  font-size: ${fontSize('xl')};
`;

export const StyledHighlightTitle = styled(Heading3)`
  color: ${color('info_500')};
`;
